// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3d_FZ","title":"FrontImage_title__SFkTB"};